<template>
  <div class="home">
    <h1>欢迎使用 蔚来有途 后台管理系统</h1>
  </div>
</template>

<script setup>

</script>

<style lang="less">
</style>